let languagePickerLink = document.querySelector(".language-picker-link");
let closeBox = document.querySelector(".close-box");
let languageModalToggle = document.querySelector(".language-modal-toggle");

if(languagePickerLink) {
    languagePickerLink.addEventListener("click", function() {
        document.querySelector(".language-holder-information").classList.add("active");
        document.querySelector("body").classList.add("active");
    });
}

if(closeBox) {
    closeBox.addEventListener("click", function() {
        document.querySelector(".language-holder-information").classList.remove("active");
        document.querySelector("body").classList.remove("active");
    });
}

if(languageModalToggle) {
    languageModalToggle.addEventListener("click", function() {
        document.querySelector(".language-holder-information").classList.remove("active");
        document.querySelector("body").classList.remove("active");
    });
}